import { Injectable } from '@angular/core';

@Injectable()
export class Enplanements {
    airCarrier: boolean;
    airTaxi: boolean;
    commuter: boolean;
    usFlag: boolean;
    foreignFlag: boolean;
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/enplanements.ts
 **/